import React, { useState, useEffect } from "react";

const AdminOnlineBookingCommunity = () => {
  const mobNum = localStorage.getItem("moblie");

  var [tit, setTit] = useState("");
  var [firstName, setFirstName] = useState("");
  var [middleName, setMiddleName] = useState("");
  var [lastName, setLastName] = useState("");
  var [fatherName, setFatherName] = useState("");
  var [aadhaarNo, setAadhaarNo] = useState("");
  var [mobileNo, setMobileNo] = useState("");
  var [panNo, setPanNo] = useState("");
  var [email, setEmail] = useState("");
  var [gender, setGender] = useState("");
  var [dob, setDob] = useState("");
  var [addressUser, setAddressUser] = useState("");

  return (
    <>
      <div className="row justify-content-around ">
        <div className="col-4">
          <div className="form-outline mb-3">
            <label className="form-label" for="id">
              Land Type:
            </label>
            <input
              type="mobile"
              id="aadhaarcard"
              onChange={(e) => setFirstName(e.target.value)}
              className="form-control"
              placeholder="Enter here"
            />
          </div>
        </div>

        <div className="col-4">
          <div className="form-outline mb-3">
            <label className="form-label" for="id">
              Mobile Number:
            </label>
            <input
              type="mobile"
              // onChange={(e) => setMobileNo(e.target.value)}
              value={mobNum}
              disabled
              className="form-control"
              placeholder="Enter here"
            />
          </div>
        </div>

        <div className="col-4">
          <div className="form-outline mb-3 ">
            <label className="form-label" for="id">
              Locality:
            </label>
            <input
              type="mobile"
              //   onChange={(e) => setAadhaarNo(e.target.value)}
              className="form-control"
              placeholder="Enter here"
            />
          </div>
        </div>

        <div className="col-4">
          <div className="form-outline mb-3">
            <label className="form-label" for="id">
              Designation:
            </label>
            <input
              type="mobile"
              //   onChange={(e) => setPanNo(e.target.value)}
              className="form-control"
              placeholder="Enter here"
            />
          </div>
        </div>
        <div className="col-4">
          <div className="form-outline mb-3">
            <label className="form-label" for="id">
              Officers Name:
            </label>
            <input
              type="mobile"
              //   onChange={(e) => setPanNo(e.target.value)}
              className="form-control"
              placeholder="Enter here"
            />
          </div>
        </div>
        <div className="col-4">
          <div className="form-outline mb-3 ">
            <label className="form-label" for="id">
              Email:
            </label>
            <input
              type="mobile"
              //   onChange={(e) => setEmail(e.target.value)}
              className="form-control"
              placeholder="Enter here"
            />
          </div>
        </div>
    
 
        <div className="col-4">
          <div className="form-outline mb-3">
            <label className="form-label" for="id">
             Division
            </label>
            <input
              type="mobile"
              // onChange={(e) => setMobileNo(e.target.value)}
              //   value={mobNum}
              //   disabled
              className="form-control"
              placeholder="Enter here"
            />
          </div>
        </div>
        <div className="col-4">
          <div className="form-outline mb-3">
            <label className="form-label" for="id">
              Address:
            </label>
            <input
              type="mobile"
              onChange={(e) => setAddressUser(e.target.value)}
              className="form-control"
              placeholder="write your full address here"
            />
          </div>
        </div>
       
        <div className="col-4">
              <div className="form-outline mb-3">
                <label className="form-label" for="id">
                  Landline:
                </label>
                <input
                  type="mobile"
                  onChange={(e) => setAddressUser(e.target.value)}
                  className="form-control"
                  placeholder="write your full address here"
                />
              </div>
            </div>
      </div>
      
    </>
  );
};
export default AdminOnlineBookingCommunity;
